export const styles = theme => ({
  row: {
    height: 35
  },

  totalCell: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
  },

  percentCell: {
    paddingBottom: theme.spacing.unit,
    paddingRight: theme.spacing.unit
  }
})


// WEBPACK FOOTER //
// ./src/components/BigCalendar/components/BigCalendarFooter/styles.js